<template>
  <div class="ability-brand">
    <div class="ability-banner-wrapper">
      <div class="ability-banner-area w1200">
        <h1>品牌营销</h1>
        <p>帮助商家完成品牌展示、引流获客与营销转化等需求，构建品牌营销闭环</p>
        <a href="/">立即创建体验</a>
      </div>
    </div>
    <div class="brand-ct-ex-bg">
      <div class="brand-ct-ex w1200">
        <div class="ct-title">品牌营销的痛点</div>
        <div class="ct-ex-content">
          <div class="content-item">
            <img :src="require('@/assets/images/ability15.png')" />
            <div class="item-title">社交流量渠道分散</div>
            <div class="item-content">
              社交流量渠道分散，难以聚集统一有效管理
            </div>
          </div>
          <div class="content-item">
            <img :src="require('@/assets/images/ability16.png')" />
            <div class="item-title">营销获客方式老旧单一</div>
            <div class="item-content">
              传播方式老旧单一，无法有效吸引和促成转化
            </div>
          </div>
          <div class="content-item">
            <img :src="require('@/assets/images/ability17.png')" />
            <div class="item-title">用户画像模糊跟进低效</div>
            <div class="item-content">只能广撒网式跟进运营，低效缺乏针对性</div>
          </div>
          <div class="content-item">
            <img :src="require('@/assets/images/ability18.png')" />
            <div class="item-title">转化路径冗长易流失</div>
            <div class="item-content">
              转化路径复杂且冗长，大量新用户流失浪费
            </div>
          </div>
          <div class="content-item">
            <img :src="require('@/assets/images/ability19.png')" />
            <div class="item-title">品牌传播效果难溯源</div>
            <div class="item-content">
              数据捕捉困难，无法溯源归因和分析转化结果
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="brand-ct-loop-bg">
      <div class="brand-ct-loop w1200">
        <div class="ct-title">从流量获客到成交转化，实现全链路品牌营销</div>
        <img :src="require('@/assets/images/ability20.png')" />
      </div>
    </div>
    <div class="brand-ct-white-bg">
      <div class="brand-ct-white w1200">
        <div class="text">
          <div class="ct-title">整合全渠道流量入口</div>
          <div class="text-content">
            流量终端：整合微信H5、微信小程序、微页面、知链助手等多种流量终端，
            占据每个流量聚集入口，持续引流获客
          </div>
        </div>
        <img :src="require('@/assets/images/ability21.png')" />
      </div>
    </div>
    <div class="brand-ct-color-bg">
      <div class="brand-ct-color w1200 flex-row-reverse">
        <div class="text">
          <div class="ct-title">一步进店减少转化流失</div>
          <div class="text-content">
            缩短转化路径：微信、社群、朋友圈传播知识店铺或课程内容，直接进入访问，无需登录或下载任何终端，减少冗长路径带来的流失
          </div>
        </div>
        <img :src="require('@/assets/images/ability22.png')" />
      </div>
    </div>
    <div class="brand-ct-white-bg">
      <div class="brand-ct-white w1200">
        <div class="text">
          <div class="ct-title">边播边卖，高效引流和变现</div>
          <div class="text-content">
            直播营销：通过直播实现传播引流、现场互动、产品演示、在线答疑，增强用户信任，轻松实现边播边卖，提升传播引流和购买转化
          </div>
        </div>
        <img :src="require('@/assets/images/ability23.png')" />
      </div>
    </div>
    <div class="brand-ct-color-bg">
      <div class="brand-ct-color w1200 flex-row-reverse">
        <div class="text">
          <div class="ct-title">裂变工具助力营销获客</div>
          <div class="text-content">
            裂变玩法：推广员、拼团、裂变海报、涨粉神器等多样引流获客工具，让每个用户变身为推广传播的触点
          </div>
        </div>
        <img :src="require('@/assets/images/ability24.png')" />
      </div>
    </div>
    <div class="brand-ct-white-bg">
      <div class="brand-ct-white w1200">
        <div class="text">
          <div class="ct-title">促销玩法刺激订单和销量</div>
          <div class="text-content">
            促销玩法：秒杀、优惠券、限时折扣等多样营销工具，刺激成交效率，打造爆款涨销量
          </div>
        </div>
        <img :src="require('@/assets/images/ability25.png')" />
      </div>
    </div>
    <div class="brand-ct-color-bg">
      <div class="brand-ct-color w1200 flex-row-reverse">
        <div class="text">
          <div class="ct-title">精准用户画像营销触达</div>
          <div class="text-content">
            用户画像：结合转化数据与付费用户标签信息，包括地域、年龄、活跃信息等，生成高价值用户画像，实现高效精准营销触达
          </div>
        </div>
        <img :src="require('@/assets/images/ability26.png')" />
      </div>
    </div>
    <div>
      <div class="ability-block-advantage w1200">
        <p class="advantage-title">知链的优势</p>
        <div class="advantage-list">
          <div class="advantage-item">
            <img :src="require('@/assets/images/ability27.png')" alt="" />
            <h6>专注知识产品变现</h6>
            <p>多年专注深耕知识付费，更专业的内容服务变现系统</p>
          </div>
          <div class="advantage-item">
            <img :src="require('@/assets/images/ability28.png')" alt="" />
            <h6>自主品牌展示</h6>
            <p>打通社交流量渠道，构建自主品牌展示矩阵</p>
          </div>
          <div class="advantage-item">
            <img :src="require('@/assets/images/ability29.png')" alt="" />
            <h6>完整的经营闭环</h6>
            <p>从品牌营销-内容交付变现-用户管理的经营闭环</p>
          </div>
          <div class="advantage-item">
            <img :src="require('@/assets/images/ability30.png')" alt="" />
            <h6>数据化经营分析</h6>
            <p>涵盖获客、交易、商品等的全流程经营数据分析</p>
          </div>
        </div>
        <div v-if="$store.state.sceneClassName !== 'app'" class="ct-eva-title">
          客户评价
        </div>
        <div
          v-if="$store.state.sceneClassName !== 'app'"
          class="ct-eva-content"
        >
          <img :src="require('@/assets/images/ability31.png')" />
          <div class="eva-description">
            <div class="eva-desc-title">清华五道口云课堂</div>
            <div class="eva-desc-content">
              知链的直播等功能，成功让我们将传统优势线下教育向线上延伸，获得了潜在的合作机会和后续业务发展的启发。
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-case-list></v-case-list>
    <div class="ct-eva-box" v-if="$store.state.sceneClassName === 'app'">
      <div class="ct-eva-title">客户评价</div>
      <div class="ct-eva-content">
        <img :src="require('@/assets/images/ability13.png')" />
        <div class="eva-description">
          <div class="eva-desc-title">21世纪经济报道</div>
          <div class="eva-desc-content">
            知链解决我们与内容的联动，通过知链内容市场能一键获取好课，大大节省了我们的时间成本。
          </div>
        </div>
      </div>
    </div>
    <v-free
      title="现在创建店铺，解决传播引流和成交转化难题"
      desc="专业客户经理解答指引 贴心解决您的问题"
      href=""
    ></v-free>
  </div>
</template>

<script>
import Free from '@/components/Free';
import CaseList from '@/components/CaseList';
export default {
  data() {
    return {
      isOpen: false
    };
  },
  components: {
    'v-free': Free,
    'v-case-list': CaseList
  },
  methods: {
    openSee() {
      this.isOpen = true;
    }
  }
};
</script>

<style lang="scss">
.ability-brand {
  .ability-banner-wrapper {
    position: relative;
    padding-top: 218px;
    height: 640px;
    width: 100%;
    color: #fff;
    background-color: #1472ff;
    background-image: url('~@/assets/images/ability14.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: auto 640px;
  }
  .ability-banner-wrapper .ability-banner-area h1 {
    margin-bottom: 32px;
    font-size: 64px;
    line-height: 72px;
    font-weight: 600;
  }
  .ability-banner-wrapper .ability-banner-area p {
    margin-bottom: 72px;
    font-size: 20px;
    font-weight: 400;
    line-height: 28px;
    width: 400px;
  }
  .ability-banner-wrapper .ability-banner-area a {
    display: block;
    width: 144px;
    height: 44px;
    line-height: 44px;
    background: #fff;
    border-radius: 22px;
    color: #1472ff;
    text-align: center;
    font-size: 14px;
    font-weight: 500;
  }
  .ability-banner-wrapper .ability-banner-area a:hover {
    background: #3d91ff;
    color: #fff;
  }
  .ability-banner-wrapper .ability-banner-area a:active {
    background: #1159d6;
    color: #fff;
  }
  .ability-block-advantage .advantage-item,
  .ability-block-advantage .ct-eva-content {
    background: #fff;
    box-shadow: 0 8px 24px 0 rgba(0, 0, 0, 0.04), 0 0 20px 0 rgba(0, 0, 0, 0.03);
    border-radius: 8px;
  }
  .ability-block-advantage {
    padding: 96px 0;
  }
  .ability-block-advantage .advantage-title {
    margin-bottom: 64px;
    font-size: 36px;
    font-weight: 500;
    color: #333;
    line-height: 44px;
  }
  .ability-block-advantage .advantage-list {
    display: flex;
    justify-content: space-between;
  }
  .ability-block-advantage .advantage-item {
    padding: 40px 16px;
    width: 268px;
    height: 364px;
    margin-left: 32px;
    text-align: center;
  }
  .ability-block-advantage .advantage-item:first-child {
    margin-left: 0;
  }
  .ability-block-advantage .advantage-item img {
    margin-bottom: 24px;
    width: 176px;
    height: 176px;
  }
  .ability-block-advantage .advantage-item h6 {
    margin-bottom: 8px;
    font-size: 20px;
    font-weight: 500;
    color: #333;
    line-height: 28px;
  }
  .ability-block-advantage .advantage-item p {
    font-size: 16px;
    font-weight: 400;
    color: #666;
    line-height: 24px;
  }
  .ability-block-advantage .ct-eva-title {
    margin-top: 64px;
    font-size: 28px;
    font-weight: 500;
    color: #333;
    line-height: 36px;
  }
  .ability-block-advantage .ct-eva-content {
    margin-top: 32px;
    width: 1168px;
    height: 140px;
    padding-left: 16px;
    display: flex;
  }
  .ability-block-advantage .ct-eva-content img {
    width: 140px;
    height: 140px;
  }
  .ability-block-advantage .eva-description {
    margin-left: 16px;
    display: flex;
    flex-direction: column;
    padding-top: 24px;
    color: #333;
  }
  .ability-block-advantage .eva-desc-title {
    font-size: 20px;
    font-weight: 500;
    line-height: 28px;
  }
  .ability-block-advantage .eva-desc-content {
    margin-top: 8px;
    width: 976px;
    height: 48px;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
  }
  .ability-block-advantage,
  .flex-column-center {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .brand-ct-ex-bg {
    background: #fff;
  }
  .brand-ct-ex .ct-ex-content {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    margin-top: 64px;
  }
  .brand-ct-ex .content-item {
    width: 368px;
    height: 220px;
    text-align: center;
    margin-left: 32px;
  }
  .brand-ct-ex .content-item:first-child,
  .brand-ct-ex .content-item:nth-child(4) {
    margin-left: 0;
  }
  .brand-ct-ex .content-item:nth-child(n + 4) {
    margin-top: 56px;
  }
  .brand-ct-ex .content-item img {
    width: 112px;
    height: 112px;
    border-radius: 50%;
  }
  .brand-ct-ex .content-item .item-title {
    margin-top: 24px;
    font-size: 20px;
    font-weight: 500;
    color: #333;
    line-height: 28px;
  }
  .brand-ct-ex .content-item .item-content {
    width: 240px;
    height: 48px;
    margin-top: 8px;
    font-size: 16px;
    font-weight: 400;
    color: #666;
    line-height: 24px;
  }
  .brand-ct-loop-bg {
    background: rgba(20, 114, 255, 0.04);
  }
  .brand-ct-loop img {
    margin-top: 64px;
    width: 1168px;
  }
  .brand-ct-color img,
  .brand-ct-white img {
    width: 668px;
  }
  .brand-ct-white-bg {
    background: #fff;
  }
  .brand-ct-color-bg {
    background: rgba(20, 114, 255, 0.04);
  }
  .brand-ct-pro-bg {
    background: #fff;
  }
  .brand-ct-pro .ct-pro-content {
    margin-top: 64px;
  }
  .brand-ct-pro .content-item {
    margin-left: 32px;
    width: 268px;
    height: 364px;
    background: #fff;
    border-radius: 8px;
    text-align: center;
  }
  .brand-ct-pro .content-item:first-child {
    margin-left: 0;
  }
  .brand-ct-pro img {
    width: 176px;
    height: 176px;
  }
  .brand-ct-pro .item-title {
    margin-top: 24px;
    font-size: 20px;
    font-weight: 500;
    color: #333;
    line-height: 28px;
  }
  .brand-ct-pro .item-content {
    margin-top: 8px;
    width: 236px;
    font-size: 16px;
    font-weight: 400;
    color: #666;
    line-height: 24px;
  }
  .brand-ct-pro .ct-eva-title {
    margin-top: 64px;
    font-size: 28px;
    font-weight: 500;
    color: #333;
    line-height: 36px;
  }
  .brand-ct-pro .ct-eva-content {
    margin-top: 32px;
    width: 1168px;
    height: 140px;
    background: #fff;
    border-radius: 8px;
    padding-left: 16px;
    display: flex;
  }
  .brand-ct-pro .ct-eva-content img {
    width: 140px;
    height: 140px;
  }
  .brand-ct-pro .eva-description {
    margin-left: 16px;
    display: flex;
    flex-direction: column;
    padding-top: 24px;
    color: #333;
  }
  .brand-ct-pro .eva-desc-title {
    font-size: 20px;
    font-weight: 500;
    line-height: 28px;
  }
  .brand-ct-pro .eva-desc-content {
    margin-top: 8px;
    width: 976px;
    height: 48px;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
  }
  .ct-title {
    font-size: 36px;
    font-weight: 500;
    color: #333;
    line-height: 44px;
  }
  .brand-ct-color,
  .brand-ct-ex,
  .brand-ct-loop,
  .brand-ct-pro,
  .brand-ct-white {
    padding: 96px 0;
  }
  .brand-ct-ex,
  .brand-ct-ex .content-item,
  .brand-ct-loop,
  .brand-ct-pro,
  .brand-ct-pro .content-item,
  .flex-column-center {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .brand-ct-color,
  .brand-ct-pro .ct-pro-content,
  .brand-ct-white,
  .flex-row-center {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .text {
    display: flex;
    flex-direction: column;
    color: #333;
    width: 468px;
  }
  .text-content {
    margin-top: 24px;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
  }
}
.app .ability-brand {
  padding-top: 1.04rem;
  .ability-banner-wrapper {
    height: 8.64rem;
    background-color: #1472ff;
    background-position: center;
    background-position-y: -0.96rem;
    background-size: cover;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0.96rem 0.32rem 0;
    background-image: url('~@/assets/images/ability14_app.png');
    text-align: center;
    h1 {
      font-size: 0.8rem;
      line-height: 0.88rem;
      margin-bottom: 0px;
    }
    p {
      margin: 0.24rem auto 0;
      font-size: 0.32rem;
      font-weight: 400;
      line-height: 0.48rem;
      width: 5.6rem;
    }
    a {
      border: none;
      outline: 0;
      margin: 0.48rem auto 0;
      width: 3.2rem;
      height: 0.8rem;
      border-radius: 0.88rem;
      font-size: 0.32rem;
      font-weight: 500;
      line-height: 0.8rem;
    }
  }
  .brand-ct-loop,
  .brand-ct-ex,
  .brand-ct-white,
  .brand-ct-color {
    padding: 1.28rem 0.32rem;
  }
  .brand-ct-white,
  .brand-ct-ex,
  .brand-ct-color {
    display: block;
  }
  .brand-ct-ex {
    .ct-title {
      font-size: 0.56rem;
      line-height: 0.72rem;
      font-weight: normal;
    }
    .ct-ex-content {
      margin-top: 0.96rem;
      display: block;
      .content-item {
        position: relative;
        display: block;
        width: 100%;
        height: 1.6rem;
        padding-left: 1.92rem;
        text-align: left;
        margin-left: 0;
        & > img {
          position: absolute;
          left: 0;
          top: 0;
          width: 1.6rem;
          height: 1.6rem;
        }
        .item-title {
          margin-top: 0;
          font-size: 0.32rem;
          line-height: 0.48rem;
        }
        .item-content {
          width: auto;
          height: auto;
          margin-top: 0.16rem;
          font-size: 0.28rem;
          line-height: 0.44rem;
        }
        &:not(:first-child) {
          margin-top: 0.64rem;
        }
      }
    }
  }
  .ct-title {
    font-size: 0.56rem;
    line-height: 0.72rem;
  }
  .brand-ct-loop img,
  .brand-ct-white img,
  .brand-ct-color img {
    width: auto;
    max-width: 100%;
    margin-top: 0.96rem;
  }
  .text {
    width: auto;
  }
  .text-content {
    margin-top: 0.32rem;
    font-size: 0.28rem;
    font-weight: 400;
    color: #333;
    line-height: 0.44rem;
  }
  .ability-block-advantage {
    padding: 1.28rem 0.32rem;
    .advantage-title {
      font-size: 0.56rem;
      line-height: 0.72rem;
      margin-bottom: 0.96rem;
    }
    .advantage-list {
      flex-wrap: wrap;
      justify-content: space-between;
    }
    .advantage-item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 0;
      width: 3.28rem;
      height: 5.56rem;
      border-radius: 0.16rem;
      margin-left: 0;
      h6 {
        height: 0.48rem;
        font-size: 0.32rem;
        font-weight: 500;
        color: #333;
        line-height: 0.48rem;
        margin-top: 0.32rem;
        margin-bottom: 0;
      }
      p {
        width: 2.32rem;
        margin-top: 0.16rem;
        font-size: 0.28rem;
        font-weight: 400;
        color: #666;
        line-height: 0.44rem;
        height: 1.32rem;
      }
      img {
        width: 2.32rem;
        height: 2.32rem;
        margin: 0;
      }
      &:nth-child(n + 3) {
        margin-top: 0.96rem;
      }
    }
  }
  .case-list {
    padding-bottom: 0;
  }
  .ct-eva-box {
    padding: 1px 0.32rem 1.12rem;
    background: #f6f9ff;

    .ct-eva-title {
      margin-top: 0.96rem;
      font-size: 0.4rem;
      line-height: 0.57rem;
      text-align: center;
    }
    .ct-eva-content {
      margin-top: 0.96rem;
      width: 6.86rem;
      background: #fff;
      padding: 0.32rem;
      font-size: 0.24rem;
      line-height: 0.48rem;
      display: flex;
      box-shadow: 0 0.2rem 0.6rem 0 rgba(102, 102, 102, 0.08);
      border-radius: 0.16rem;
      img {
        width: 1.6rem;
        height: 1.6rem;
      }
      .eva-description {
        margin-left: 0.32rem;
        display: flex;
        flex-direction: column;
        font-size: 0.24rem;
        line-height: 0.48rem;
        text-align: left;
      }
      .eva-desc-title {
        font-weight: 500;
      }
      .eva-desc-content {
        font-weight: 400;
      }
    }
  }
}
</style>
